"use client";

import { useMemo } from "react";
import { twMerge } from "tailwind-merge";

export default function Label({
  title,
  icon,
  colors = "primary",
  size = "medium",
  className,
  classNameText,
  univColor = false,
}) {
  const Icon = icon;

  const { isColor, padding, sizeIcon, sizeText } = useMemo(() => {
    let listSize = {
      tiny: "",
      small: "py-1 px-3",
      medium: "py-2 px-4",
      large: "py-3 px-5",
    };
    let sizeIcon = {
      tiny: "h-5 w-5",
      small: "h-5 w-5",
      medium: "h-5 w-5",
      large: "5-6 w-6",
    };
    let sizeText = {
      tiny: "text-button-small",
      small: "text-button-small",
      medium: "p2-medium",
      large: "text-button-medium",
    };
    const isColor = univColor ? colors : `${colors}GON`;
    return {
      padding: listSize?.[size],
      sizeIcon: sizeIcon?.[size],
      sizeText: sizeText?.[size],
      isColor,
    };
  }, [size, colors]);
  return (
    <div
      className={twMerge(
        className,
        padding,
        `flex gap-1 items-center rounded`,
        colors == "success"
          ? `bg-${isColor}-100 text-${isColor}-600`
          : colors == "warning"
          ? `bg-${isColor}-50 text-${isColor}-600`
          : `bg-${isColor}-50 text-${isColor}-600`,
        "select-none"
      )}>
      {!icon ? null : (
        <div>
          <Icon className={sizeIcon} />
        </div>
      )}
      <p className={twMerge(sizeText, "capitalize", classNameText)}>{title}</p>
    </div>
  );
}
